import React, {useState, useEffect, createRef} from 'react';
import clsx from "clsx";
import {makeStyles} from "@mui/styles";
import {useHistory} from "react-router-dom";
import Toolbar from "@mui/material/Toolbar";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import CodeIcon from '@mui/icons-material/Code';
import DeleteIcon from "@mui/icons-material/Delete";
import SettingsIcon from "@mui/icons-material/Settings";
import StyleIcon from '@mui/icons-material/Style';
import {Divider} from "@mui/material";
import List from "@mui/material/List";
import ListSubheader from '@mui/material/ListSubheader';
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {styled} from "@mui/material/styles";
import MuiDrawer from "@mui/material/Drawer";
import Icon from "@mui/material/Icon";
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from "@mui/material/Typography";
import Stack from '@mui/material/Stack';
import Button from "@mui/material/Button";
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { v4 as uuidv4 } from 'uuid';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import WebFont from 'webfontloader';

import logo from '../logo.png';
import logoIcon from '../logo-icon.png';

import Heading from "../components/Heading";
import InputEmail from "../components/InputEmail";
import ShortText from "../components/ShortText";
import LongText from "../components/LongText";
import Submit from "../components/Submit";
import Empty from "../components/Empty";
import Paragraph from "../components/Paragraph";
import Number from "../components/Number";
import Date from "../components/Date";
import SingleChoice from "../components/SingleChoice";
import MultipleChoice from "../components/MultipleChoice";
import Dropdown from "../components/Dropdown";
import Hidden from "../components/Hidden";
import FormControl from "@mui/material/FormControl";
import TextField from "@mui/material/TextField";
import NativeSelect from "@mui/material/NativeSelect";
import InputLabel from "@mui/material/InputLabel";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import ImageUploader from "../components/ImageUploader";

export const FontFamilies = {
    default: [
        'Arial',
        'Arial Black',
        'Avant Garde',
        'Bookman',
        'Brush Script MT',
        'Comic Sans MS',
        'Courier New',
        'Helvetica',
        'Georgia',
        'Garamond',
        'Palatino',
        'Tahoma',
        'Times New Roman',
        'Trebuchet MS',
        'Verdana'
    ],
    google: [
        'Lato',
        'Open Sans',
        'Raleway',
        'Roboto',
        'Inter',
    ]
}

const useStyles = makeStyles(theme => ({
    root: {},
    formList: {
        listStyleType: 'none',

        '& > li': {
          borderRadius: 5,
          position: 'relative',
        },

        '& > li .selectedControls': {
            display: 'none',
            position: 'absolute',
            left: '100%',
            top: '50%',
            transform: 'translateY(-50%)',

            '& > button': {
                color: '#fff',
                margin: '5px 0 5px 15px',

                '&.removeIcon': {
                    backgroundColor: '#d73027'
                },

                '&.settingsIcon': {
                    backgroundColor: '#757575'
                },

                '&.dragIndicator': {
                  opacity: 0.25,
                  color: '#757575',
                  backgroundColor: 'transparent',
                  position: 'absolute',
                  top: '50%',
                  left: '-43px',
                  transform: 'translateY(-50%)',
                }

            }

        },

        '& > li.selected': {
            boxShadow: '0 0 0 2px #0293e2',
        },

        '& > li.selected .selectedControls': {
            display: 'block',
        },

    },
    rightBar: {
        display: 'flex',
        height: '100%',
        position: 'fixed',
        top: 0,
        right: 0
    },
    leftBar: {
        display: 'flex',
        height: '100%',
        position: 'fixed',
    },
    leftBatToggler: {
        position: 'absolute !important',
        top: 12,
        left: '100%',
        backgroundColor: '#e0e0e0 !important',
        border: '1px solid #e0e0e0 !important',
        borderLeft: 'none !important',
    },
    formWrapper: {
        display: 'flex',
        width: 'auto',
        justifyContent: 'center',

        '&.sendiio-form-family': {

            '&-roboto': {
                fontFamily: "'Roboto', sans-serif"
            },

            '&-open-sans': {
                fontFamily: "'Open Sans', sans-serif"
            },

            '&-lato': {
                fontFamily: "'Lato', sans-serif"
            },

            '&-inter': {
                fontFamily: "'Inter', sans-serif"
            },

            '&-raleway': {
                fontFamily: "'Raleway', sans-serif"
            },

        }

    },
    configuratorBtn: {
        backgroundColor: '#fff !important',
        position: 'fixed !important',
        right: 24,
        top: 24,
        zIndex: 0
    },
    logoFileName: {
        fontSize: "small",
        wordBreak: 'break-all',
        whiteSpace: 'break-spaces',
    },
    logo: {
        maxWidth: '100%',
        height: 'auto',
        padding: 0,
        margin: 0
    },
}));

const drawerWidth = 240;

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(6),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(7),
                },
            }),
        },
    }),
);

const RightDrawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
    ({ theme, open }) => ({
        '& .MuiDrawer-paper': {
            zIndex: 1,
            position: 'relative',
            whiteSpace: 'nowrap',
            width: drawerWidth,
            transition: theme.transitions.create('width', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.enteringScreen,
            }),
            boxSizing: 'border-box',
            ...(!open && {
                overflowX: 'hidden',
                transition: theme.transitions.create('width', {
                    easing: theme.transitions.easing.sharp,
                    duration: theme.transitions.duration.leavingScreen,
                }),
                width: theme.spacing(0),
                [theme.breakpoints.up('sm')]: {
                    width: theme.spacing(0),
                },
            }),
        },
    }),
);

const grid = 8;

const getItemStyle = (isDragging, draggableStyle) => ({
    // some basic styles to make the items look a bit nicer
    userSelect: "none",
    padding: grid * 2,
    margin: `0 0 ${grid}px 0`,

    // change background colour if dragging
    background: isDragging ? "orange" : "transparent",

    // styles we need to apply on draggables
    ...draggableStyle
});

const getListStyle = isDraggingOver => ({
    background: isDraggingOver ? "lightyellow" : "transparent",
    padding: grid,
    width: 'auto'
});

// a little function to help us with reordering the result
const reorderForm = (list, startIndex, endIndex) => {

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
};

const addToForm = (list, newElement, newIndex) => {

    const result = Array.from(list);

    // add unique ID
    result.splice(newIndex, 0, { ...newElement, id: uuidv4()});

    return result;

}

const removeFromForm = (list, id) => {

    const result = Array.from(list);

    const removeIndex = list.map(function(item) {return item.id; }).indexOf(id);

    result.splice(removeIndex, 1);

    return result;

}

const formElements = [
    {
        id: uuidv4(),
        type: 'heading',
        content: 'Heading',
        icon: 'title',
        data: {
            id: null,
            type: 'heading',
            title: 'Heading',
            subtitle: '',
            size: 'default',
            textAlignment: 'left',
        }
    },
    {
        id: uuidv4(),
        type: 'email',
        content: 'Email',
        icon: 'email',
        data: {
            id: null,
            type: 'email',
            label: 'Email',
            sublabel: 'example@example.com',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'short_text',
        content: 'Short Text',
        icon: 'input',
        data: {
            id: null,
            type: 'short_text',
            label: 'Type a question',
            sublabel: '',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'long_text',
        content: 'Long Text',
        icon: 'text_snippet',
        data: {
            id: null,
            type: 'long_text',
            label: 'Type a question',
            sublabel: '',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'hidden',
        content: 'Hidden',
        icon: 'visibility_off',
        data: {
            id: null,
            type: 'hidden',
            value: '',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'number',
        content: 'Number',
        icon: 'looks_one',
        data: {
            id: null,
            type: 'number',
            label: 'Number',
            sublabel: '',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'date',
        content: 'Date',
        icon: 'event',
        data: {
            id: null,
            type: 'date',
            label: 'Date',
            sublabel: '',
            placeholder: 'DD-MM-YYYY',
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'single_choice',
        content: 'Single Choice',
        icon: 'radio_button_checked',
        data: {
            id: null,
            type: 'single_choice',
            label: 'Type a question',
            options: [
                'Type option 1',
                'Type option 2',
                'Type option 3',
                'Type option 4',
            ],
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'multiple_choice',
        content: 'Multiple Choice',
        icon: 'check_box',
        data: {
            id: null,
            type: 'multiple_choice',
            label: 'Type a question',
            options: [
                'Type option 1',
                'Type option 2',
                'Type option 3',
                'Type option 4',
            ],
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'dropdown',
        content: 'Dropdown',
        icon: 'arrow_drop_down_circle',
        data: {
            id: null,
            type: 'dropdown',
            label: 'Type a question',
            sublabel: '',
            options: [
                'Type option 1',
                'Type option 2',
                'Type option 3',
                'Type option 4',
            ],
            labelAlignment: 'top',
            required: true,
        }
    },
    {
        id: uuidv4(),
        type: 'paragraph',
        content: 'Paragraph',
        icon: 'text_fields',
        data: {
            id: null,
            type: 'paragraph',
            text: 'Click to edit this text',
            size: 'default',
            textAlignment: 'left',
        }
    },
    {
        id: uuidv4(),
        type: 'submit',
        content: 'Submit',
        icon: 'send',
        data: {
            id: null,
            type: 'submit',
            buttonText: 'Submit',
            buttonAlignment: 'auto',
        }
    },
];

const data = {
    formId: 1,
    formWidthAuto: true,
    formWidth: 600,
    formHeightAuto: true,
    formHeight: 300,
    formColorScheme: 'default',
    formTemplate: 'default',
    formFontFamily: 'roboto',
    formLogo: {
        image: '',
        filename: '',
        width: null,
        height: null,
        alignment: 'center',
    },
    formContent: [
        {
            "id": "84503ac4-d749-42c5-8741-c919e3841740",
            "type": "heading",
            "title": "Heading",
            "subtitle": "",
            "size": "default",
            "textAlignment": "left"
        },
        {
            "id": "6df38a74-6892-4dc6-bad0-c50cb0b63d8c",
            "type": "email",
            "label": "Email",
            "sublabel": "example@example.com",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "cdce3cca-84d0-4c12-9e44-c4b648446828",
            "type": "short_text",
            "label": "Type a question",
            "sublabel": "",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "e6a6af26-daa0-4a20-92c6-eb1cfcd0c157",
            "type": "long_text",
            "label": "Type a question",
            "sublabel": "",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "765458a0-421c-4b2c-b84d-6f0be4ee5195",
            "type": "hidden",
            "value": "",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "689fb32e-b675-4e78-9591-d15de07fc0cb",
            "type": "number",
            "label": "Number",
            "sublabel": "",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "0eb3fe84-5ac6-4730-b331-001b9f79e9b2",
            "type": "date",
            "label": "Date",
            "sublabel": "",
            "placeholder": "DD-MM-YYYY",
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "959479cd-4679-4dc4-9a07-a8b45610221b",
            "type": "single_choice",
            "label": "Type a question",
            "options": [
                "Type option 1",
                "Type option 2",
                "Type option 3",
                "Type option 4"
            ],
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "53a169b7-b292-4ea4-8c3e-34cb4fd72f1c",
            "type": "multiple_choice",
            "label": "Type a question",
            "options": [
                "Type option 1",
                "Type option 2",
                "Type option 3",
                "Type option 4"
            ],
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "afb43bcf-494e-4ee5-8bc5-054fc601c6e8",
            "type": "dropdown",
            "label": "Type a question",
            "sublabel": "",
            "options": [
                "Type option 1",
                "Type option 2",
                "Type option 3",
                "Type option 4"
            ],
            "labelAlignment": "top",
            "required": true
        },
        {
            "id": "c306e2b9-6d70-45ea-ad56-27bb9ea46b4b",
            "type": "paragraph",
            "text": "Click to edit this text",
            "size": "default",
            "textAlignment": "left"
        },
        {
            "id": "8c50cb62-2116-48f7-a3e5-fe66d19ae3a4",
            "type": "submit",
            "buttonText": "Submit",
            "buttonAlignment": "auto"
        }
    ],
}

export default function Form(props) {

    const history = useHistory();
    const classes = useStyles(props);

    // for leftbar
    const [open, setOpen] = React.useState(true);

    const [formData, setFormData] = useState(data);

    const handleUpdateFormData = (data) => {

        let currentForm = { ...formData };

        let itemIndex = currentForm.formContent.findIndex(item => item.id === data.id);

        currentForm.formContent[itemIndex] = data;

        setFormData(currentForm);

    }

    const handleUpdateLogoData = (data) => {

        let currentForm = { ...formData };

        currentForm.formLogo = data;

        setFormData(currentForm);

    }

    const handleLabelsAlignment = (e) => {

        const target = e.target;
        let value = target.value;

        formData.formContent.forEach((item) => {

            if(item.labelAlignment){

                item.labelAlignment = value;

            }

        });

        setFormData({...formData});

    }

    const handleInputChange = (e, item) => {

        const target = e.target;
        let value = target.value;
        let name = target.name;

        if(!item){

            if(name === 'formLogo[alignment]'){

                const currentData = {...formData};

                currentData.formLogo.alignment = value;

                setFormData(currentData);


            } else {

                if(name === 'formWidthAuto' || name === 'formHeightAuto'){

                    value = e.target.checked;

                }

                setFormData({...formData, [name]: value});

            }

        } else {

            const index = formData.formContent.findIndex(element => element.id === item.id);

            if(name === 'required'){

                value = e.target.checked;

            }

            if(name === 'options'){

                value = value.split(/\r?\n|\r|\n/g);

            }

            formData.formContent[index][name] = value;

            setFormData({...formData});

        }

    };

    // for configurator
    const configuratorRef = createRef();
    const [openConfigurator, setOpenConfigurator] = useState(false);
    const [configuratorData, setConfiguratorData] = useState({
        'type': 'form',
        'itemID': null,
        'data': data,
        'updateFormData': handleUpdateFormData
    });

    let activeConfiguratorItem = configuratorData.itemID;

    const handleOpenConfigurator = (e, item) => {

        setOpenConfigurator(true);

        // open form configurator
        if(!item){

            setConfiguratorData({
                'type': 'form',
                'itemID': item,
                'data': data,
                'updateFormData': handleUpdateFormData
            });

        // open element configurator
        } else {

            setConfiguratorData({
                'type': 'item',
                'itemID': item,
                'data': data
            });

        }

    };

    // for code dialog
    const [openCode, setOpenCode] = React.useState(false);

    const handleOpenCode = () => {
        setOpenCode(true);
    };

    const handleCloseCode = () => {
        setOpenCode(false);
    };



    const toggleDrawer = () => {

        setOpen(!open);

    };

    const onDragEnd = (result) => {

        const { source, destination } = result;

        let currentForm = { ...formData };

        // dropped outside the list
        if (!result.destination) {
            return;
        }

        switch (source.droppableId) {

            case 'userForm':

                const items = reorderForm(
                    currentForm.formContent,
                    result.source.index,
                    result.destination.index
                );

                currentForm.formContent = items;

                setFormData(currentForm);

                break;

            case 'formElements':

                const newItems = addToForm(
                    currentForm.formContent,
                    formElements[source.index].data,
                    destination.index,
                );

                currentForm.formContent = newItems;

                setFormData(currentForm);

                break;


            default:

                    return false;

        }

        document.querySelectorAll('.sendiio-element').forEach((item) => {

            if(item.getAttribute('data-rbd-draggable-id') === result.draggableId){

                item.classList.add('selected');

            }

        });

    }

    const formElement = (item) => {

        switch (item.type) {

            case "heading":

                return <Heading data={item} updateFormData={handleUpdateFormData} />;

            case "email":

                return <InputEmail data={item} updateFormData={handleUpdateFormData} />

            case "short_text":

                return <ShortText data={item} updateFormData={handleUpdateFormData} />

            case "long_text":

                return <LongText data={item} updateFormData={handleUpdateFormData} />

            case "hidden":

                return <Hidden data={item} updateFormData={handleUpdateFormData} />

            case "number":

                return <Number data={item} updateFormData={handleUpdateFormData} />

            case "date":

                return <Date data={item} updateFormData={handleUpdateFormData} />

            case "paragraph":

                return <Paragraph data={item} updateFormData={handleUpdateFormData} />

            case "single_choice":

                return <SingleChoice data={item} updateFormData={handleUpdateFormData} />

            case "multiple_choice":

                return <MultipleChoice data={item} updateFormData={handleUpdateFormData} />

            case "dropdown":

                return <Dropdown data={item} updateFormData={handleUpdateFormData} />

            case "submit":

                return <Submit data={item} updateFormData={handleUpdateFormData} />

            default:

                return null;

        }

    }

    const handleClickEmptyElement = () => {

        console.log('test');

    }

    const handleRemove = (e, id) => {

        e.stopPropagation();

        let currentForm = { ...formData };

        const newItems = removeFromForm(currentForm.formContent, id);

        currentForm.formContent = newItems;

        setFormData(currentForm);

    }

    const addToFormManually = (item, index) => {

        let currentForm = { ...formData };

        const submitIndex = currentForm.formContent.findIndex(element => element.type === 'submit');

        const formLength = currentForm.formContent.length;

        const newItems = addToForm(
            currentForm.formContent,
            formElements[index].data,
            submitIndex >= 0 ? submitIndex : formLength,
        );

        currentForm.formContent = newItems;

        setFormData(currentForm);

    }

    const handleSelectElement = (e) => {

        if(!document.querySelector('.configuratorWrapper').contains(e.target)){

            document.querySelectorAll('.sendiio-element').forEach(item => {

                if(item.contains(e.target)){

                    item.classList.add('selected');

                } else {

                    item.classList.remove('selected');

                }

            });

            const configuratorWrapper = document.querySelector('.configuratorWrapper');

            if(!configuratorWrapper.contains(e.target)){

                setOpenConfigurator(false);

            }

        }

    }

    const elementConfigurator = (item) => {

        switch (item.type) {

            case 'heading':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHeadingTitle-${item.id}`}
                            name="title"
                            value={item.title}
                            type="text"
                            label="Heading Title"
                            id="headingTitle"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHeadingSubtitle-${item.id}`}
                            name="subtitle"
                            value={item.subtitle}
                            type="text"
                            label="Heading Subtitle"
                            id="headingSubtitle"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`headingSize-${item.id}`}>Heading Size</InputLabel>
                        <NativeSelect
                            key={`confHeadingSize-${item.id}`}
                            name="size"
                            id="headingSize"
                            value={item.size}
                            label="Heading Size"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="small">Small</option>
                            <option value="default">Default</option>
                            <option value="large">Large</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`headingAlign-${item.id}`}>Text Alignment</InputLabel>
                        <NativeSelect
                            key={`confHeadingAlignment-${item.id}`}
                            name="textAlignment" 
                            id="headingAlignment"
                            value={item.textAlignment}
                            label="Text Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                </>

            case 'email':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confEmailLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="emailLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confEmailSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="emailSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'short_text':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confShortTextLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="shortTextLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confShortTextSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="shortTextSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'long_text':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLongTextLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="longTextLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confLongTextSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="longTextSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'hidden':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confHiddenValue-${item.id}`}
                            name="value"
                            value={item.value}
                            type="text"
                            label="Value"
                            id="hiddenValue"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                </>

            case 'number':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNumberLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="numberLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confNumberSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="numberSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'date':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDateLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="dateLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDateSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="dateSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'single_choice':

                let singleOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        singleOptions = option;
                    } else {
                        singleOptions = `${singleOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confSingleChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="singleChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confSingleChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={singleOptions}
                            type="text"
                            label="Options"
                            id="singleChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'multiple_choice':

                let multipleOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        multipleOptions = option;
                    } else {
                        multipleOptions = `${multipleOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confMultipleChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="multipleChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confMultipleChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={multipleOptions}
                            type="text"
                            label="Options"
                            id="multipleChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'dropdown':

                let dropdownOptions = '';

                item.options.forEach((option, index) => {

                    if(index === 0){
                        dropdownOptions = option;
                    } else {
                        dropdownOptions = `${dropdownOptions}\n${option}`;
                    }

                });

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownChoiceLabel-${item.id}`}
                            name="label"
                            value={item.label}
                            type="text"
                            label="Label"
                            id="dropdownChoiceLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownSublabel-${item.id}`}
                            name="sublabel"
                            value={item.sublabel}
                            type="text"
                            label="Sublabel"
                            id="dropdownSublabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confDropdownChoiceOptions-${item.id}`}
                            multiline
                            rows={6}
                            name="options"
                            value={dropdownOptions}
                            type="text"
                            label="Options"
                            id="dropdownChoiceOptions"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`labelAlignment-${item.id}`}>Label Alignment</InputLabel>
                        <NativeSelect
                            key={`confLabelAlignment-${item.id}`}
                            name="labelAlignment"
                            id="labelAlignment"
                            value={item.labelAlignment}
                            label="Label Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="top">Top</option>
                            <option value="left">Left</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <FormControlLabel control={
                            <Checkbox checked={item.required}
                                      name="required"
                                      onChange={e => handleInputChange(e, item)} />
                        } label="Required" />
                    </FormControl>

                </>

            case 'paragraph':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confTextLabel-${item.id}`}
                            name="text"
                            value={item.text}
                            type="text"
                            label="Text"
                            id="textLabel"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                </>

            case 'submit':

                return <>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <TextField
                            key={`confButtonText-${item.id}`}
                            name="buttonText"
                            value={item.buttonText}
                            type="text"
                            label="Button Text"
                            id="buttonText"
                            variant="outlined"
                            fullWidth
                            onInput={e => handleInputChange(e, item)}
                        />
                    </FormControl>

                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                        <InputLabel id={`buttonAlignment-${item.id}`}>Button Alignment</InputLabel>
                        <NativeSelect
                            key={`confButtonAlignment-${item.id}`}
                            name="buttonAlignment"
                            id="buttonAlignment"
                            value={item.buttonAlignment}
                            label="Button Alignment"
                            onChange={e => handleInputChange(e, item)}>
                            <option value="auto">Auto</option>
                            <option value="left">Left</option>
                            <option value="center">Center</option>
                            <option value="right">Right</option>
                        </NativeSelect>
                    </FormControl>

                </>

            default:

                return <>Item {item.id}</>

        }

    }

    useEffect(() => {

        document.addEventListener('click', handleSelectElement, true);

        return () => {
            document.removeEventListener('click', handleSelectElement, true);
        };

    }, []);

    useEffect(() => {

        WebFont.load({
            google: {
                families: FontFamilies.google
            }
        });

    }, []);

    return <>

        <DragDropContext onDragEnd={onDragEnd}>

            <Box sx={{ display: 'flex', height: '100%' }}>

                <div className={clsx(classes.leftBar)}>

                    <Drawer variant="permanent" open={open}>

                        <Toolbar
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                                px: [open ? 3 : 1],
                            }}
                        >

                            <img src={open ? logo : logoIcon} className={classes.logo} alt="Sendiio" />

                        </Toolbar>

                        <Divider />

                        <List component="nav">

                            {open && <ListSubheader component="div" id="nested-list-subheader">
                                Form Elements
                            </ListSubheader>}

                            <Droppable droppableId="formElements" isDropDisabled={true}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        //isDraggingOver={snapshot.isDraggingOver}
                                    >

                                        {formElements.map((item, index) => (
                                            <Draggable
                                                key={item.id}
                                                draggableId={item.id}
                                                index={index}>
                                                {(provided, snapshot) => (
                                                    <React.Fragment>
                                                        <div
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={() => addToFormManually(item, index)}
                                                            //isDragging={snapshot.isDragging}
                                                            style={
                                                                provided.draggableProps.style
                                                            }>
                                                            <ListItemButton>
                                                                <ListItemIcon>
                                                                    <Icon color="action">{item.icon}</Icon>
                                                                </ListItemIcon>
                                                                <ListItemText primary={item.content} />
                                                            </ListItemButton>
                                                        </div>
                                                        {snapshot.isDragging && (

                                                            <ListItemButton>
                                                                <ListItemIcon>
                                                                    <Icon color="action">{item.icon}</Icon>
                                                                </ListItemIcon>
                                                                {/*<ListItemText primary={`draggling` + item.content} />*/}
                                                                <ListItemText primary={item.content} />
                                                            </ListItemButton>

                                                        )}
                                                    </React.Fragment>
                                                )}
                                            </Draggable>
                                        ))}

                                    </div>
                                )}
                            </Droppable>

                        </List>

                    </Drawer>

                    <IconButton className={clsx(classes.leftBatToggler, 'rounded-0')} onClick={toggleDrawer}>
                        {open ? <ChevronLeftIcon/> : <ChevronRightIcon />}
                    </IconButton>

                </div>

                <Container className="form-container" maxWidth="lg" sx={{ mt: 4, mb: 4 }}>

                    <Typography typography="h2" textAlign="center">Form manager</Typography>

                    <Box className={clsx(classes.formWrapper, `sendiio-form-family-${formData.formFontFamily}`)}>

                        <div className={'sendiio-form-' + formData.formTemplate} style={{width: formData.formWidthAuto ? '460px' : `${formData.formWidth}px`}}>

                            <ImageUploader
                                logo={formData.formLogo}
                                openConfigurator={handleOpenConfigurator}
                                updateLogoData={handleUpdateLogoData} />

                            <form className={clsx('sendiio-form', `sendiio-form-color-scheme-${formData.formColorScheme}`)} style={{width: formData.formWidthAuto ? '460px' : `${formData.formWidth}px`, height: formData.formHeightAuto ? 'auto' : `${formData.formHeight}px`,  }}>

                                <Droppable droppableId="userForm">
                                    {(provided, snapshot) => (
                                        <ul {...provided.droppableProps}
                                            ref={provided.innerRef}
                                            className={clsx(classes.formList, 'form-manager-list')}
                                            style={getListStyle(snapshot.isDraggingOver)}>

                                            {formData.formContent.length > 0 && formData.formContent.map((item, index) => (

                                                <Draggable key={item.id} draggableId={item.id} index={index}>
                                                    {(provided, snapshot) => (

                                                        <li
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            className={clsx('sendiio-element', item.selected ? 'selected' : '')}
                                                            onDoubleClick={(e) => handleOpenConfigurator(e, item.id)}
                                                            style={getItemStyle(
                                                                snapshot.isDragging,
                                                                provided.draggableProps.style
                                                            )}>

                                                            {formElement(item)}

                                                            <div className="selectedControls">
                                                                <IconButton className="dragIndicator" disabled>
                                                                    <DragIndicatorIcon />
                                                                </IconButton>
                                                                <IconButton className="settingsIcon" onClick={e => handleOpenConfigurator(e, item.id)}>
                                                                    <SettingsIcon />
                                                                </IconButton>
                                                                <IconButton className="removeIcon" onClick={(e) => handleRemove(e, item.id)}>
                                                                    <DeleteIcon />
                                                                </IconButton>
                                                            </div>

                                                        </li>

                                                    )}
                                                </Draggable>

                                            ))}

                                            {formData.formContent.length === 0 &&

                                                <Draggable key="draggable-0" draggableId="draggable-0" index={0} isDragDisabled={true}>
                                                    {(provided, snapshot) =>
                                                        <li className="emptyPlaceholderLine disable-drag"
                                                            ref={provided.innerRef}
                                                            {...provided.draggableProps}
                                                            {...provided.dragHandleProps}
                                                            onClick={handleClickEmptyElement}
                                                            style={getItemStyle(snapshot.isDragging, provided.draggableProps.style)}>
                                                            <Empty/>
                                                        </li>
                                                    }
                                                </Draggable>

                                            }

                                            {provided.placeholder}

                                        </ul>
                                    )}
                                </Droppable>

                            </form>

                            <Tooltip title="Form Configurator" placement="left">
                                <IconButton
                                    className={clsx(classes.configuratorBtn, 'p-12')}
                                    color="primary"
                                    aria-label="Form Configurator"
                                    onClick={e => handleOpenConfigurator(e, null)}
                                    component="label">
                                    <StyleIcon />
                                </IconButton>
                            </Tooltip>

                        </div>

                    </Box>

                    <Stack
                        className="mt-36 pb-48 text-center"
                        spacing={2}
                        justifyContent="center"
                        direction="row">
                        <Button variant="outlined"
                                onClick={e => {

                                    e.preventDefault();

                                    history.push('/');

                                }}
                                startIcon={<ArrowBackIcon />}>
                            Previous stage
                        </Button>
                        <Button variant="contained"
                                onClick={e => {

                                    e.preventDefault();

                                    handleOpenCode();

                                }}
                                endIcon={<CodeIcon />}>
                            Generate a code
                        </Button>
                    </Stack>

                    <Dialog
                        open={openCode}
                        onClose={handleCloseCode}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                    >
                        <DialogTitle id="alert-dialog-title" align="center">
                            {"Here is your subscribe form code"}
                        </DialogTitle>
                        <DialogContent>
                            <DialogContentText id="alert-dialog-description">
                                <p>Copy and put &lt;div&gt; in place where you want the subscribe form will shown.
                                You can put a &lt;script&gt; code where ever you want:</p>
                                <pre>&lt;div id="sendiio-subscribe-form-some-number"&gt;&lt;\div&gt;</pre>
                                <pre>&lt;script src="https://sendiio.com/some_url"&gt;&lt;\script&gt;</pre>
                            </DialogContentText>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleCloseCode}>Close</Button>
                        </DialogActions>
                    </Dialog>

                </Container>

                <div ref={configuratorRef} className={clsx('configuratorWrapper', classes.rightBar)}>

                    <RightDrawer
                            variant="permanent"
                            anchor="right"
                            open={openConfigurator}>

                        <Toolbar
                            sx={{
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-start',
                            }}
                            className="px-16"
                        >

                            <Typography variant="h6" noWrap component="div">
                                Form Configurator
                            </Typography>

                        </Toolbar>

                        <Divider />

                        <div className="px-16">

                            <div className="configuratorContent">

                                <div className={clsx(activeConfiguratorItem && 'hidden', 'configuratorContentForm', 'flex', 'flex-col', 'pt-12')}>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <TextField
                                            key="formWidth"
                                            name="formWidth"
                                            value={formData.formWidth}
                                            type="number"
                                            InputProps={{ inputProps: { min: 200, max: 1200 } }}
                                            disabled={formData.formWidthAuto && true}
                                            label="Form Width"
                                            id="formWidth"
                                            variant="outlined"
                                            fullWidth
                                            onInput={e => handleInputChange(e, null)}
                                        />
                                    </FormControl>

                                    <FormControlLabel
                                        label="Auto width"
                                        control={
                                            <Checkbox
                                                name="formWidthAuto"
                                                size="small"
                                                checked={formData.formWidthAuto}
                                                onChange={e => handleInputChange(e, null)}
                                            />
                                        }
                                    />

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`formColorSchemeLabel`}>Color Scheme</InputLabel>
                                        <NativeSelect
                                            key={`confFormColorSchemeLabel`}
                                            name="formColorScheme"
                                            id="formColorScheme"
                                            defaultValue="default"
                                            label="Color Scheme"
                                            onChange={e => handleInputChange(e, null)}>
                                            <option value="default">Default</option>
                                            <option value="dark">Dark</option>
                                            <option value="blue">Blue</option>
                                            <option value="orange">Orange</option>
                                        </NativeSelect>
                                    </FormControl>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`labelsAlignment`}>Label`s Alignment</InputLabel>
                                        <NativeSelect
                                            key={`confLabelsAlignment`}
                                            name="labelsAlignment"
                                            id="labelsAlignment"
                                            defaultValue="top"
                                            label="Label Alignment"
                                            onChange={e => handleLabelsAlignment(e)}>
                                            <option value="top">Top</option>
                                            <option value="left">Left</option>
                                            <option value="right">Right</option>
                                        </NativeSelect>
                                    </FormControl>

                                    <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                        <InputLabel id={`formFontFamilyLabel`}>Font Family</InputLabel>
                                        <NativeSelect
                                            key={`confFormFontFamilyLabel`}
                                            name="formFontFamily"
                                            id="formFontFamily"
                                            defaultValue="default"
                                            label="Font Family"
                                            onChange={e => handleInputChange(e, null)}>
                                            <option value="roboto">Roboto</option>
                                            <option value="open-sans">Open Sans</option>
                                            <option value="lato">Lato</option>
                                            <option value="inter">Inter</option>
                                            <option value="raleway">Raleway</option>
                                        </NativeSelect>
                                    </FormControl>

                                    {/*<FormControl variant="outlined" className="mt-24 mb-16" fullWidth>
                                        <TextField
                                            name="formHeight"
                                            value={formData.formHeight}
                                            type="number"
                                            InputProps={{ inputProps: { min: 100, max: 1200 } }}
                                            disabled={formData.formHeightAuto && true}
                                            label="Form Height"
                                            id="formHeight"
                                            variant="outlined"
                                            fullWidth
                                            onChange={e => handleInputChange(e, null)}
                                        />
                                    </FormControl>

                                    <FormControlLabel
                                        label="Auto height"
                                        control={
                                            <Checkbox
                                                name="formHeightAuto"
                                                size="small"
                                                checked={formData.formHeightAuto}
                                                onChange={e => handleInputChange(e, null)}
                                            />
                                        }
                                    />*/}

                                    {formData.formLogo.image !== '' &&
                                        <div className="mt-36 flex flex-col">

                                            <InputLabel shrink htmlFor="logo-legend">
                                                Edit Your Logo
                                            </InputLabel>

                                            <p className={classes.logoFileName}>{formData.formLogo.filename}</p>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <InputLabel id="headingLogoAlign">Logo Alignment</InputLabel>
                                                <NativeSelect
                                                    key={`confLogoAlignment`}
                                                    name="formLogo[alignment]"
                                                    id="logoAlignment"
                                                    value={formData.formLogo.alignment}
                                                    label="Logo Alignment"
                                                    onChange={e => handleInputChange(e)}>
                                                    <option value="left">Left</option>
                                                    <option value="center">Center</option>
                                                    <option value="right">Right</option>
                                                </NativeSelect>
                                            </FormControl>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    key="formLogoWidth"
                                                    name="formLogoWidth"
                                                    value={formData.formLogo.width}
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 64, max: 1200 } }}
                                                    disabled={true}
                                                    label="Logo Width"
                                                    id="formLogoWidth"
                                                    variant="outlined"
                                                    fullWidth
                                                    onInput={e => handleInputChange(e, null)}
                                                />
                                            </FormControl>

                                            <FormControl variant="outlined" className="mt-16 mb-6" fullWidth>
                                                <TextField
                                                    key="formLogoHeight"
                                                    name="formLogoHeight"
                                                    value={formData.formLogo.height}
                                                    type="number"
                                                    InputProps={{ inputProps: { min: 64, max: 1200 } }}
                                                    disabled={true}
                                                    label="Logo Height"
                                                    id="formLogoHeight"
                                                    variant="outlined"
                                                    fullWidth
                                                    onInput={e => handleInputChange(e, null)}
                                                />
                                            </FormControl>

                                        </div>
                                    }

                                </div>

                                <div className="configuratorContentItems">
                                {formData.formContent.length > 0 && formData.formContent.map((item, index) => (

                                    <div key={`key-conf-${item.id}`} className={clsx(activeConfiguratorItem !== item.id && 'hidden', 'configuratorContentItem', 'flex', 'flex-col', 'pt-12')}>
                                        {elementConfigurator(item)}
                                    </div>

                                ))}
                                </div>

                            </div>

                        </div>

                    </RightDrawer>

                </div>

            </Box>

        </DragDropContext>

    </>;

}